const TYPE = {
   EDIT_ADD: 'EDIT_ADD',
};

export default {
   TYPE,
   FORM: {
      SECTION: {
         CONTENT: {
            TYPE: {
               FLEX_FIELDS: 'FLEX_FIELDS',
            },
         },
      },
   },
};
